import { ReactElement, useState } from 'react'
import {
  FlexWrapper,
  PageWrapper,
  SectionTitle,
  DropdownWrapper,
  EditableDropdown,
  TableWrapper,
  TableHeader,
  TableRow,
  Icon
} from '../../../components'
import strings from '../../../locale/en'
import {
  ShowAllFilter,
  SelectCheckBox,
  SelectAllWrapper
} from './subcomponents'
import Table from 'react-bootstrap/Table'
import { tableHeader } from './const'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Body } from '../../../typography'
import { FormBackWrapper } from '../User/subcomponents'

const QuestionList = (): ReactElement => {
  const [isSelectAll, setIsSelectAll] = useState(false)
  const {
    menu: {
      admin: {
        questionListing,
        selectCourse,
        selectSubject,
        selectChapter,
        showAllFilter,
        selectAll
      }
    }
  } = strings

  return (
    <PageWrapper id="container">
      <SectionTitle title={questionListing} hasBorder />
      <FlexWrapper>
        <SelectAllWrapper>
          <SelectCheckBox
            onChange={() => {
              setIsSelectAll(!isSelectAll)
            }}
          />
          <Body>{selectAll}</Body>
        </SelectAllWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={[]}
            placeholder={selectCourse}
            onBlur={() => { }}
            error={''}
            handleSelect={() => { }}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={[]}
            placeholder={selectSubject}
            onBlur={() => { }}
            error={''}
            handleSelect={() => { }}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={[]}
            placeholder={selectChapter}
            onBlur={() => { }}
            error={''}
            handleSelect={() => { }}
          />
        </DropdownWrapper>
        <ShowAllFilter>{showAllFilter}</ShowAllFilter>
      </FlexWrapper>
      <div>
        <FormBackWrapper>
          <TableWrapper>
            <Table size="sm" responsive="sm">
              <TableHeader>
                <TableRow>
                  {tableHeader?.map((header, index) => (
                    <th key={`question-list-header-${index}`}>{header}</th>
                  ))}
                </TableRow>
              </TableHeader>
              <tbody>
                <TableRow>
                  <td>
                    <SelectCheckBox checked={isSelectAll} />
                  </td>
                  <td>{'Neet'}</td>
                  <td>{'Physics'}</td>
                  <td>{'Chapter'}</td>
                  <td>{'Topic'}</td>
                  <td>{'11'}</td>
                  <td>{'Easy'}</td>
                  <td>{'MCQ'}</td>
                  <td>{'Active'}</td>
                  <td>
                    <Icon variant="outline-light" onClick={() => { }}>
                      <FontAwesomeIcon
                        icon={['far', 'trash-alt']}
                        style={{ marginRight: 10 }}
                      />
                    </Icon>
                    <Icon variant="outline-light" onClick={() => { }}>
                      <FontAwesomeIcon
                        icon={['far', 'eye']}
                        style={{ marginRight: 10 }}
                      />
                    </Icon>
                  </td>
                </TableRow>
              </tbody>
            </Table>
          </TableWrapper>
        </FormBackWrapper>
      </div>
    </PageWrapper>
  )
}

export default QuestionList
